import type { ElementType, ReactNode } from 'react'

interface MonoLabelProps {
  children: ReactNode
  /** Use the 11px variant (table headers, footer cells). */
  small?: boolean
  className?: string
  as?: ElementType
}

/**
 * The mono label used throughout the sheet: uppercase, tracked, 11-12px.
 * Every section label, part number, date and nav item goes through this.
 */
export default function MonoLabel({
  children,
  small = false,
  className = '',
  as: Tag = 'span',
}: MonoLabelProps) {
  const base = small ? 'mono-label-sm' : 'mono-label'
  return <Tag className={`${base} ${className}`.trim()}>{children}</Tag>
}
